module.exports = __webpack_public_path__ + "static/media/Icon_EE7E20.16ee64b0.png";